
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "replicated-attributes"
    }}>{`Replicated Attributes`}</h1>
    <h4 {...{
      "id": "background"
    }}>{`Background`}</h4>
    <p>{`Users want knowledge of how the entities have landed into Atlas instance, if they were created via hook ingestion or whether they were imported from another Atlas instance.`}</p>
    <p>{`This is addressed by 2 new attributes that are now part of `}<em parentName="p">{`Referenceable`}</em>{` entity type viz. `}<em parentName="p">{`replicatedFrom`}</em>{` and `}<em parentName="p">{`replicatedTo`}</em>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;